import { IAppState } from '../reducers';

export const loadedAssetMetadata = (state: IAppState) => {
  const {
    securityProfiles: {
      options, idValueMapping, productOptions,
    },
  } = state;
  const securityProfilesIsLoaded = options.length > 0 && idValueMapping.length > 0 && productOptions.length > 0;
  if (state.metatags.isLoaded && securityProfilesIsLoaded && state.lookups.isLoaded) return true;
  return false;
};
